<template>
  <div>
    <v-menu
      v-for="([text, rounded], index) in btns"
      :key="text"
      :rounded="rounded"
      offset-y
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          small
          elevation="0"
          light
          :class="textColorClass"
          :color="menuColor"
          class="ml-1 text-capitalize"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon
            left
            dark
          >
            mdi-account-tie
          </v-icon>
          {{ text }}
        </v-btn>
      </template>

      <v-list dense>
        <v-list-item
          class="py-0 my-0 list-item-height"
          dense
          link
          @click="goto('/create-driver')"
        >
          <v-list-item-title v-text="'Register Driver'" />
        </v-list-item>
        <v-list-item
          class="py-0 my-0 list-item-height"
          dense
          link
          @click="goto('/drivers-list')"
        >
          <v-list-item-title v-text="'Drivers List'" />
        </v-list-item>
        <v-list-item
          class="py-0 my-0 list-item-height"
          dense
          link
        >
          <v-list-item-title
            @click="goto('/drivers/applications')"
            v-text="'Applications'"
          />
        </v-list-item>
        <v-list-item
          class="py-0 my-0 list-item-height"
          dense
          link
          @click="goto('/taxis')"
        >
          <v-list-item-title v-text="'Taxis'" />
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-list-item-action v-on="on">
                <p
                    v-if="unverifiedTaxiCount > 0"
                    style="position: relative; top: 0px; right: 7px; color: #ef5757; font-size: smaller"
                >
                  <b>{{ unverifiedTaxiCount }}</b>
                </p>
              </v-list-item-action>
            </template>
            <p>Taxis</p>
          </v-tooltip>
        </v-list-item>
        <v-list-item
          class="py-0 my-0 list-item-height"
          dense
          link
          @click="goto('/invoices')"
        >
          <v-list-item-title v-text="'Invoices'" />
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "DriverNavigation",
  data: () => ({
    btns: [
      ['Drivers', '0'],
    ],
    colors: ['deep-purple accent-4', 'error', 'teal darken-1'],
    items: [
        'Out of Area'
    ],
    menuRoutes: [
      'create-driver', 'drivers-list', 'drivers/applications'
    ],
  }),
  computed: {
    isRouteInMenu () {
      return this.menuRoutes.includes(this.$route.name)
    },
    menuColor () {
      if (this.isRouteInMenu) {
        return 'deep-purple accent-4'
      }
      return ''
    },
    textColorClass () {
      if (this.isRouteInMenu) {
        return 'white--text'
      }
      return ''
    },
    unverifiedTaxiCount() {
      return this.$store.getters.getTaxisToReviewCount;
    }
  },
  methods: {
    goto (route, isNewTab = false) {
      if (isNewTab) {
        return window.open(route)
      }
      return this.$router.push(route)
    }
  }
}
</script>

<style scoped>

.list-item-height {
  min-height: 28px !important;
}

</style>